import React from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import CapacitorTestSuite from '../components/CapacitorTestSuite';
import { Capacitor } from '@capacitor/core';
import { Seo } from "../components/Seo";
import { generateNoIndexSEO } from "../lib/seo/metaGenerators";

const CapacitorTest = () => {
  const platform = Capacitor.getPlatform();
  const isNative = Capacitor.isNativePlatform();

  return (
    <Container className="py-4">
      <Seo {...generateNoIndexSEO("Capacitor Test")} />
      <Row>
        <Col>
          <h2 className="mb-4">Capacitor Integration Testing</h2>
          
          <Alert variant="info" className="mb-4">
            <h5>Current Environment</h5>
            <p className="mb-1">
              <strong>Platform:</strong> {platform}
            </p>
            <p className="mb-1">
              <strong>Native Platform:</strong> {isNative ? 'Yes' : 'No'}
            </p>
            <p className="mb-0">
              <strong>User Agent:</strong> {navigator.userAgent}
            </p>
          </Alert>

          <CapacitorTestSuite />

          <Card className="mt-4">
            <Card.Header>
              <h5>Testing Instructions</h5>
            </Card.Header>
            <Card.Body>
              <h6>Web Testing (Current Environment)</h6>
              <ul>
                <li>Click "Run All Tests" to test Capacitor features</li>
                <li>Some features will show as "not available" on web platform</li>
                <li>This is expected behavior for web testing</li>
              </ul>

              <h6>Mobile Testing Checklist</h6>
              <div className="row">
                <div className="col-md-6">
                  <h6>iOS Testing</h6>
                  <ul>
                    <li>Install Xcode on macOS</li>
                    <li>Run: <code>npm run ios</code></li>
                    <li>Test on iOS Simulator</li>
                    <li>Test on physical iOS device</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h6>Android Testing</h6>
                  <ul>
                    <li>Install Android Studio</li>
                    <li>Install Android SDK</li>
                    <li>Run: <code>npm run android</code></li>
                    <li>Test on Android Emulator</li>
                    <li>Test on physical Android device</li>
                  </ul>
                </div>
              </div>

              <h6>Feature Testing</h6>
              <ul>
                <li><strong>Camera:</strong> Test photo capture functionality</li>
                <li><strong>Location:</strong> Verify GPS access and accuracy</li>
                <li><strong>Haptic Feedback:</strong> Test vibration on device</li>
                <li><strong>Push Notifications:</strong> Test notification delivery</li>
                <li><strong>Offline Mode:</strong> Test app behavior without internet</li>
                <li><strong>App State:</strong> Test background/foreground transitions</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CapacitorTest; 